import SinggleChoice from "./KrSinggleChoice.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrSinggleChoice = install(SinggleChoice); // 生成带有 install 方法的组件

export default KrSinggleChoice;
